import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SEMANTIC, UI } from '../../styles/theme';
import KycProgressBar from '../KycProgressBar';
import API from '../../api';
import { useAppModal } from '../../hooks/useAppModal';

const PhoneVerification = () => {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const { t } = useTranslation();
  const { modal, showModal } = useAppModal();

  const handleSendCode = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await API.post('/kyc/check-phone', { phone });
      if (res.data.exists) {
        setError(t('kyc.phone.error_already_registered'));
        return;
      }
      setCodeSent(true);
      showModal({ type: 'info', title: t('kyc.phone.alert_sms_sent') });
    } catch (err) {
      setError(t('kyc.phone.error_check'));
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    if (code === '111111') {
      try {
        await API.post('/kyc/verify-phone', { user_id: userId, phone, code });
        setSuccess(true);
        setTimeout(() => {
          navigate('/kyc/personal-data');
        }, 1000);
      } catch (err) {
        setError(t('kyc.phone.error_generic'));
      }
    } else {
      setError(t('kyc.phone.error_invalid'));
    }
  };

  return (
    <>
    {modal}
    <div
      style={{
        backgroundColor: SEMANTIC.backgroundApp,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: UI.spacing.lg,
      }}
    >
      <div style={{ maxWidth: '500px', margin: '0 auto', width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: UI.spacing.xl }}>
          <img
            src={`${process.env.PUBLIC_URL}/Logo_Kuesto.png`}
            alt="Kuesto Logo"
            style={{ width: '120px' }}
          />
        </div>

        {/* Progress Bar */}
        <KycProgressBar currentStep={2} />

        <div
          style={{
            backgroundColor: SEMANTIC.backgroundCard,
            borderRadius: UI.borderRadius.md,
            padding: UI.spacing.xl,
            boxShadow: UI.shadow.card,
          }}
        >
          <h2
            style={{
              color: SEMANTIC.actionBuy,
              marginBottom: UI.spacing.md,
              fontSize: UI.fontSize.title,
              fontWeight: UI.fontWeight.bold,
              textAlign: 'center',
            }}
          >
            {t('kyc.phone.title')}
          </h2>

          {!codeSent ? (
            <>
              <p style={{ color: SEMANTIC.textSecondary, marginBottom: UI.spacing.xl, textAlign: 'center', fontSize: UI.fontSize.md }}>
                {t('kyc.phone.description_1')}
              </p>
              {error && (
                <div style={{ backgroundColor: 'rgba(255, 77, 77, 0.1)', border: `2px solid ${SEMANTIC.actionSell}`, borderRadius: UI.borderRadius.sm, padding: UI.spacing.md, marginBottom: UI.spacing.lg, color: SEMANTIC.actionSell, textAlign: 'center' }}>
                  {error}
                </div>
              )}
              <form onSubmit={handleSendCode}>
                <div style={{ marginBottom: UI.spacing.lg }}>
                  <label htmlFor="phone" style={{ color: SEMANTIC.textPrimary, display: 'block', marginBottom: UI.spacing.sm, fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold }}>
                    {t('kyc.phone.phone_label')}
                  </label>
                  <input type="tel" id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={t('kyc.phone.phone_placeholder')} required style={{ width: '100%', padding: UI.spacing.md, backgroundColor: SEMANTIC.backgroundCard, color: SEMANTIC.textPrimary, border: '1px solid rgba(255,255,255,0.15)', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.md }} />
                </div>
                <button type="submit" style={{ width: '100%', padding: UI.spacing.md, backgroundColor: SEMANTIC.ctaPrimary, color: SEMANTIC.ctaPrimaryText, border: 'none', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.lg, fontWeight: UI.fontWeight.bold, cursor: 'pointer' }}>
                  {t('kyc.phone.send_sms')}
                </button>
              </form>
            </>
          ) : (
            <>
              <p style={{ color: SEMANTIC.textSecondary, marginBottom: UI.spacing.xl, textAlign: 'center', fontSize: UI.fontSize.md }}>
                {t('kyc.phone.description_2', { phone })}
              </p>
              {success && (
                <div style={{ backgroundColor: 'rgba(0, 255, 136, 0.1)', border: `2px solid ${SEMANTIC.actionBuy}`, borderRadius: UI.borderRadius.sm, padding: UI.spacing.md, marginBottom: UI.spacing.lg, color: SEMANTIC.actionBuy, textAlign: 'center' }}>
                  {t('kyc.phone.success')}
                </div>
              )}
              {error && (
                <div style={{ backgroundColor: 'rgba(255, 77, 77, 0.1)', border: `2px solid ${SEMANTIC.actionSell}`, borderRadius: UI.borderRadius.sm, padding: UI.spacing.md, marginBottom: UI.spacing.lg, color: SEMANTIC.actionSell, textAlign: 'center' }}>
                  {error}
                </div>
              )}
              <form onSubmit={handleVerify}>
                <div style={{ marginBottom: UI.spacing.lg }}>
                  <label htmlFor="code" style={{ color: SEMANTIC.textPrimary, display: 'block', marginBottom: UI.spacing.sm, fontSize: UI.fontSize.md, fontWeight: UI.fontWeight.bold }}>
                    {t('kyc.phone.code_label')}
                  </label>
                  <input type="text" id="code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="111111" maxLength="6" required style={{ width: '100%', padding: UI.spacing.md, backgroundColor: SEMANTIC.backgroundCard, color: SEMANTIC.textPrimary, border: '1px solid rgba(255,255,255,0.15)', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.lg, textAlign: 'center', letterSpacing: '0.5em' }} />
                </div>
                <button type="submit" disabled={code.length !== 6} style={{ width: '100%', padding: UI.spacing.md, backgroundColor: code.length === 6 ? SEMANTIC.ctaPrimary : SEMANTIC.backgroundDisabled, color: code.length === 6 ? SEMANTIC.ctaPrimaryText : SEMANTIC.textDisabled, border: 'none', borderRadius: UI.borderRadius.sm, fontSize: UI.fontSize.lg, fontWeight: UI.fontWeight.bold, cursor: code.length === 6 ? 'pointer' : 'not-allowed' }}>
                  {t('kyc.phone.verify_button')}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: UI.spacing.lg }}>
                <button onClick={() => setCodeSent(false)} style={{ background: 'transparent', border: 'none', color: SEMANTIC.textSecondary, fontSize: UI.fontSize.sm, cursor: 'pointer' }}>
                  {t('kyc.phone.change_number')}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
    </>
  );
};

export default PhoneVerification;
